import { useEffect, useState } from 'react';
import { resolveCoordinates } from '../scene3d/coords';
import { postalCodesApi } from '../services/api';
import { useGardenSettings } from '../context/GardenSettingsContext';

/**
 * useSunCoordinates - Lat/Lon des Gartens für den Sonnenstand (#604/#605)
 *
 * Löst die Koordinaten dreistufig auf (settings → PLZ-Lookup → DE-Zentroid,
 * siehe scene3d/coords.js) und trägt einen erfolgreichen Lookup in die
 * Settings nach (Selbstheilung für Bestandsgärten). Geteilt von der
 * 3D-Ansicht und dem 2D-Schatten-Overlay.
 *
 * @param {object} [options]
 * @param {boolean} [options.active=true] - nur auflösen, wenn wirklich gebraucht
 *   (spart den PLZ-Lookup, solange die Funktion nicht sichtbar ist)
 * @returns {{latitude:number, longitude:number, source:string}|null} null bis gelöst
 */
export default function useSunCoordinates({ active = true } = {}) {
  const { settings, updateSettings } = useGardenSettings();
  const { latitude, longitude, zipCode } = settings;
  const [coords, setCoords] = useState(null);

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    resolveCoordinates(
      { latitude, longitude, zipCode },
      { lookupPostalCode: postalCodesApi.lookup }
    ).then((res) => {
      if (cancelled) return;
      setCoords(res);
      if (res.source === 'lookup') {
        updateSettings({ latitude: res.latitude, longitude: res.longitude });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [active, latitude, longitude, zipCode, updateSettings]);

  return coords;
}
